import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

interface CardFooterProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
}

const CardFooter = ({ children, className, ...props }: CardFooterProps) => {
    return (
        <div className={clsx('card-footer', className)} {...props}>
            {children}
        </div>
    );
};

export default CardFooter;
